import React, { useCallback, useEffect, useState } from 'react';
import BaraemQuestionStep2 from './BaraemQuestionStep2';
import BaraemQuestionStep1 from './baraemQuestionStep1';
import BaraemQuestionStep3 from './BaraemQuestionStep3';
import BaraemQuestionStep4 from './BaraemQuestionStep4';
import BaraemQuestionStep5 from './BaraemQuestionStep5';
import BaraemQuestionStep6 from './BaraemQuestionStep6';
import { getQuestionForBaraem } from '../../../services/liferay/baraemServices';
import FeedBackForm from './FeedBackForm';
import QuestionSubmitPopup from './QuestionSubmitPopup';
import AppointmentPopup from './AppointmentPopup';
import AppointmentForm from './AppointmentForm';
import FeedBackFormSubmit from './FeedBackFormSubmit';
import { useLocation, useNavigate } from 'react-router-dom';
import { getLayoutDirection } from '../../../utils/util';
import { Loader } from "../../../common/Loader";

const BaraemQuestionDashboard = ({ translationMap }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    baraemUsername,
    hcNumber,
    questionnaireids,
    questionnaire,
    age,
    tbluserQuestionnaireStatusId,
    childDetails
  } = location.state || {};
  const [questionStep, setQuestionStep] = useState(-1);
  const [responses, setResponses] = useState({});
  const [questionSteps, setQuestionSteps] = useState({
    General: [],
    'Gross Motor': [],
    'Fine Motor': [],
    'Speech And Language': [],
    'Social And Emotional': [],
    'Problem Solving And Self Help': [],
    'Feedback': [],
    "ScheduleAppointment": []
  });
  const categoryMap = {
    'General': 'General',
    'GROSS MOTOR': 'Gross Motor',
    'FINE MOTOR': 'Fine Motor',
    'SPEECH AND LANGUAGE': 'Speech And Language',
    'SOCIAL AND EMOTIONAL': 'Social And Emotional',
    'PROBLEM SOLVING AND SELF-HELP': 'Problem Solving And Self Help',
    'Feedback': 'Feedback',
    "ScheduleAppointment": "ScheduleAppointment"
  };

  const [isApiLoading, setIsApiLoading] = useState(false);


  const [stepSummary, setStepSummary] = useState({
    General: { numberOfYes: 0, numberOfNo: 0, isPositiveCase: 0 },
    GrossMotor: { numberOfYes: 0, numberOfNo: 0, isPositiveCase: 0 },
    FineMotor: { numberOfYes: 0, numberOfNo: 0, isPositiveCase: 0 },
    SpeechAndLanguage: { numberOfYes: 0, numberOfNo: 0, isPositiveCase: 0 },
    SocialAndEmotional: { numberOfYes: 0, numberOfNo: 0, isPositiveCase: 0 },
    ProblemSolvingAndSelfHelp: { numberOfYes: 0, numberOfNo: 0, isPositiveCase: 0 }
  });

  const updateStepSummary = useCallback((step, summaryData) => {
    setStepSummary((prevSummary) => {
      const currentStep = prevSummary[step];

      if (
      currentStep.numberOfYes === summaryData.numberOfYes &&
      currentStep.numberOfNo === summaryData.numberOfNo &&
      currentStep.isPositiveCase === summaryData.isPositiveCase)
      {
        return prevSummary;
      }

      return {
        ...prevSummary,
        [step]: summaryData
      };
    });
  }, []);

  useEffect(() => {


    // console.log('Step summary updated:', stepSummary);
  }, [stepSummary]);const combineStepSummary = () => {

    let totalYes = 0;
    let totalNo = 0;
    let isOverallPositiveCase = 0;


    Object.values(stepSummary).forEach((step) => {

      totalYes += step.numberOfYes;
      totalNo += step.numberOfNo;

      if (step.isPositiveCase === 1) {
        isOverallPositiveCase = 1;
      }
    });

    return {
      totalYes,
      totalNo,
      isPositiveCase: isOverallPositiveCase
    };
  };
  useEffect(() => {
    const startQuestionAndAnswer = async () => {
      try {
        setIsApiLoading(true);

        const result = await getQuestionForBaraem(parseInt(questionnaireids));
        setIsApiLoading(false);

        const groupedQuestions = Object.keys(result.data).reduce((acc, key) => {
          const normalizedKey = categoryMap[key];
          if (normalizedKey && result.data[key].length > 0) {
            acc[normalizedKey] = result.data[key];
          }
          return acc;
        }, {
          General: [],
          'Gross Motor': [],
          'Fine Motor': [],
          'Speech And Language': [],
          'Social And Emotional': [],
          'Problem Solving And Self Help': [],
          'Feedback': [],
          "ScheduleAppointment": []
        });

        setQuestionSteps(groupedQuestions);
        setQuestionStep(1);

      } catch (error) {
        setIsApiLoading(false);


      }
    };

    startQuestionAndAnswer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questionnaireids]);
  const generalQuestionCount = questionSteps.General?.length || 0;
  const grossMotorCount = questionSteps['Gross Motor']?.length || 0;
  const fineMotorCount = questionSteps['Fine Motor']?.length || 0;
  const speechAndLangCount = questionSteps['Speech And Language']?.length || 0;
  const socialAndEmoCount = questionSteps['Social And Emotional']?.length || 0;
  // const [translationMap, setTranslationMap] = useState(null);

  // useEffect(() => {
  //     // window.parent.scrollTo(0, 0);
  //     if (questionStep === -1) {
  //         getWebContent(BaraemWebContent.webStructurePKProcess, BaraemWebContent.templateId).then((result) => {
  //             console.log("get webcontent for baraem")
  //             const element = document.querySelector("#baraemQuestion");
  //             const sanitizedContent = DOMPurify.sanitize(result?.data);
  //             element.innerHTML = sanitizedContent;
  //         })
  //     }
  // }, [questionStep]);

  if (isApiLoading) {
    return (
      <Loader />);

  }

  return (
    <>
            <div className={` custombody_color ${getLayoutDirection()}`} id="sectionManageDependent">

                {questionStep === 100 && <div>
                    <section className="w-100 clearfix BaraemMainSection" id="CoverPlanActive" style={{
            marginTop: "30px"
          }}>
                        <div className="container customContainer">
                            <div className="Title_Inner_Box">
                                <h6 className="MainTitleOne">
                                    {translationMap?.childDevAssessment ?? "Child Development Assessment"}
                                </h6>
                            </div>
                            <div className="cover_inner_wrapper">
                                <div className="cover_main_box1">
                                    <div className="baraem_main_inner_wrapper">
                                        <form className="form_box">
                                            <div className="Inner_Box">
                                                <div className="custom_accordion_box3">
                                                    <span className="accordion-button">
                                                        {baraemUsername}
                                                    </span>
                                                    <div className="card card-body">
                                                        <div className="accordion_content_box">
                                                            <ul className="ul_box">
                                                                <li>
                                                                    <p>
                                                                        {translationMap?.age ?? "Age"}{":"} <b>{age} {translationMap?.months ?? "months"}</b>
                                                                    </p>
                                                                </li>
                                                                <li>
                                                                    <p>
                                                                        {translationMap?.theQuestionnaireText ?? "Questionnaire:"} <b>{questionnaire}</b>
                                                                    </p>
                                                                </li>
                                                            </ul>
                                                            <h6 className="MainTitleOne">
                                                                {translationMap?.prematureNote ??
                                "Note: If your child was born premature, corrected age is calculated according to the duration of pregnancy."
                                }
                                                            </h6>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div id="baraemQuestion"></div>
                                            <div className="Inner_Box">
                                                <div className="form_buton_box">
                                                    <span>
                                                        <button onClick={(e) => {
                              e.preventDefault();
                              if (questionnaireids) {


                                //  startQuestionAndAnswer(parseInt(questionnaireids))
                              } else {console.error("Question ID is undefined");}
                            }}
                            className="blue_btn_link">
                                                            {translationMap?.startQuestionnaire ?? "Start Questionnaire"}
                                                        </button>
                                                    </span>
                                                    <span>
                                                        <button onClick={() => navigate("/")}
                            className="bluetrans_btn_link">
                                                            {translationMap?.back ?? "Back"}
                                                        </button>
                                                    </span>
                                                </div>
                                            </div>

                                        </form>
                                    </div>
                                </div>
                                <div className="cover_main_box2">

                                </div>
                            </div>
                        </div>
                    </section>
                </div>
        }
                <div>
                    {
          questionStep === 1 &&
          <BaraemQuestionStep1 setQuestionStep={setQuestionStep} questions={questionSteps.General}
          responses={responses} setResponses={setResponses}
          baraemUsername={baraemUsername} hcNumber={hcNumber || childDetails.childId.toString()}
          questionnaireid={questionnaireids} age={age} startingIndex={1}
          stepSummary={stepSummary.General}
          updateStepSummary={(data) => updateStepSummary("General", data)}
          questionnaire={questionnaire} translationMap={translationMap} />


          }

                    {

          questionStep === 2 &&
          <BaraemQuestionStep2 setQuestionStep={setQuestionStep} questions={questionSteps['Gross Motor']}
          responses={responses} setResponses={setResponses}
          baraemUsername={baraemUsername} hcNumber={hcNumber || childDetails.childId.toString()}
          questionnaireid={questionnaireids} age={age} questionnaire={questionnaire}
          startingIndex={generalQuestionCount + 1}
          stepSummary={stepSummary.GrossMotor}
          updateStepSummary={(data) => updateStepSummary("GrossMotor", data)}
          combineStepSummary={combineStepSummary} translationMap={translationMap} />

          }
                    {
          questionStep === 3 &&
          <BaraemQuestionStep3 setQuestionStep={setQuestionStep} questions={questionSteps['Fine Motor']}
          responses={responses} setResponses={setResponses}
          baraemUsername={baraemUsername} hcNumber={hcNumber || childDetails.childId.toString()}
          questionnaireid={questionnaireids} age={age} questionnaire={questionnaire}
          startingIndex={generalQuestionCount + grossMotorCount + 1}
          stepSummary={stepSummary.FineMotor}
          updateStepSummary={(data) => updateStepSummary("FineMotor", data)}
          translationMap={translationMap} />


          }
                    {
          questionStep === 4 && <BaraemQuestionStep4 setQuestionStep={setQuestionStep}
          questions={questionSteps['Speech And Language']}
          responses={responses} setResponses={setResponses}
          baraemUsername={baraemUsername} hcNumber={hcNumber || childDetails.childId.toString()}
          questionnaireid={questionnaireids} age={age}
          questionnaire={questionnaire}
          startingIndex={generalQuestionCount + grossMotorCount + fineMotorCount + 1}
          stepSummary={stepSummary.SpeechAndLanguage}
          updateStepSummary={(data) => updateStepSummary("SpeechAndLanguage", data)}
          translationMap={translationMap} />


          }
                    {
          questionStep === 5 && <BaraemQuestionStep5 setQuestionStep={setQuestionStep}
          questions={questionSteps['Social And Emotional']}
          responses={responses} setResponses={setResponses}
          baraemUsername={baraemUsername} hcNumber={hcNumber || childDetails.childId.toString()}
          questionnaireid={questionnaireids} age={age}
          questionnaire={questionnaire}
          startingIndex={generalQuestionCount + grossMotorCount + fineMotorCount + speechAndLangCount + 1}
          stepSummary={stepSummary.SocialAndEmotional}
          updateStepSummary={(data) => updateStepSummary("SocialAndEmotional", data)}
          translationMap={translationMap} />


          }
                    {
          questionStep === 6 &&
          <BaraemQuestionStep6
            setQuestionStep={setQuestionStep}
            questions={questionSteps['Problem Solving And Self Help']}
            responses={responses}
            setResponses={setResponses}
            baraemUsername={baraemUsername}
            hcNumber={hcNumber || childDetails.childId.toString()}
            questionnaireid={questionnaireids}
            age={age}
            questionnaire={questionnaire}
            startingIndex={generalQuestionCount + grossMotorCount + fineMotorCount + speechAndLangCount + socialAndEmoCount + 1}
            stepSummary={stepSummary.ProblemSolvingAndSelfHelp}
            updateStepSummary={(data) => updateStepSummary("ProblemSolvingAndSelfHelp", data)}
            combineStepSummary={combineStepSummary}
            tbluserQuestionnaireStatusId={tbluserQuestionnaireStatusId}
            translationMap={translationMap}
            childDetails={childDetails} />


          }
          {
          questionStep >= 7 && questionStep <= 11 &&
          <div style={{
            position: "relative",
            zIndex: 1,
            opacity: 1,
            pointerEvents: "none"
          }}>
            <BaraemQuestionStep6
              setQuestionStep={setQuestionStep}
              questions={questionSteps['Problem Solving And Self Help']}
              responses={responses}
              setResponses={setResponses}
              baraemUsername={baraemUsername}
              hcNumber={hcNumber || childDetails.childId.toString()}
              questionnaireid={questionnaireids}
              age={age}
              questionnaire={questionnaire}
              startingIndex={generalQuestionCount + grossMotorCount + fineMotorCount + speechAndLangCount + socialAndEmoCount + 1}
              stepSummary={stepSummary.ProblemSolvingAndSelfHelp}
              updateStepSummary={(data) => updateStepSummary("ProblemSolvingAndSelfHelp", data)}
              combineStepSummary={combineStepSummary}
              tbluserQuestionnaireStatusId={tbluserQuestionnaireStatusId}
              translationMap={translationMap}
              childDetails={childDetails} />
            
        </div>

          }
          {
          questionStep >= 7 && questionStep <= 11 &&
          <div style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 10
          }}>
            {questionStep === 7 && <QuestionSubmitPopup setQuestionStep={setQuestionStep} baraemUsername={baraemUsername} translationMap={translationMap} />}
            {questionStep === 8 && <AppointmentPopup setQuestionStep={setQuestionStep} baraemUsername={baraemUsername} translationMap={translationMap} />}
            {questionStep === 9 && <FeedBackForm setQuestionStep={setQuestionStep} questions={questionSteps['Feedback']} baraemUsername={baraemUsername} hcNumber={hcNumber || childDetails.childId.toString()} questionnaireid={questionnaireids} translationMap={translationMap} />}
            {questionStep === 10 && <FeedBackFormSubmit translationMap={translationMap} />}
            {questionStep === 11 && <AppointmentForm setQuestionStep={setQuestionStep} questions={questionSteps['ScheduleAppointment']} baraemUsername={baraemUsername} hcNumber={hcNumber} questionnaireid={questionnaireids} translationMap={translationMap} />}
        </div>

          }
                </div>
            </div>
        </>);

};

export default BaraemQuestionDashboard;